<template src="./scheduler.html" />

<script>
import {
  BButton,
  BCol,
  BRow,
  BForm,
  BBreadcrumb,
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import '@core/scss/vue/libs/vue-good-table.scss'
import FormSchedule from '@/views/scheduler/FormSchedule.vue'
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import apiCommon from '@/views/apiCommon'
import ImportScheduler from '@/views/scheduler/importScheduler/ImportScheduler.vue'
import * as XLSX from 'xlsx'
import Ripple from 'vue-ripple-directive'
import api from './api'

export default {
  name: 'Scheduler',
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BCol,
    BRow,
    BForm,
    BBreadcrumb,
    BCard,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    vSelect,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    VueGoodTable,
    FormSchedule,
    BFormCheckbox,
    ImportScheduler
  },
  data() {
    return {
      user: getUser(),
      table: {
        fields: [
          {
            field: 'subjectName', label: 'Học phần', sortable: false, type: 'string',
          },
          {
            field: 'creditClassCode', label: 'Lớp độc lập', sortable: false, type: 'string',
          },
          {
            field: 'roomName', label: 'Phòng học', sortable: false, type: 'string',
          },
          {
            field: 'yearWeekCode', label: 'Tuần học', sortable: false, type: 'string',
          },
          {
            field: 'schedule', label: 'Thời gian', sortable: false, type: 'string',
          },
          {
            field: 'teacherName', label: 'Giảng viên', sortable: false, type: 'string',
          },
          {
            field: 'action', tdClass: 'text-center', thClass: 'text-center', label: 'Thao tác', sortable: false,
          },
        ],
        items: [],
      },
      itemsDisplay: [],
      totalRecords: 0,
      isLoading: false, // Thay loading thành isLoading cho thống nhất
      serverParams: {
        columnFilters: {},
        sort: [{ field: '', type: '' }],
        page: 1,
        perPage: 10,
      },
      dataSendForm: { isCreated: 0 },
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        trainingSystemId: '',
        courseId: '',
        courseSemesterId: '',
        yearWeekId: '',
        departmentId: '',
        subjectId: '',
        creditClassId: '',
        teacherId: '',
        dayId: '',
        status: 1,
        maxStatus: 3,
        sort: '',
      },
      teacherOptions: [],
      titleNameDelete: '',
      checkRemoveAll: '0',
      itemDelete: {},
      checkAllWeek: '',
      isHandleSaveSuccess: false,

      // Các biến từ mapGetters được chuyển vào đây
      schedulers: [], // Danh sách lịch học
      total: 0, // Tổng số bản ghi
      courses: [], // Danh sách khóa học
      trainingSystems: [], // Danh sách hệ đào tạo
      courseSemesters: [], // Danh sách học kỳ
      departments: [], // Danh sách khoa
      subjects: [], // Danh sách học phần
      creditClasses: [], // Danh sách lớp độc lập
      teachers: [], // Danh sách giảng viên
      teachersByCreditClass: [], // Danh sách giảng viên theo lớp
      days: [], // Danh sách ngày
      weeks: [], // Danh sách tuần
      columnsExport: [
        {
          label: 'Học phần',
          field: 'stringSubjectExport',
        },
        {
          label: 'Lớp độc lập',
          field: 'creditClassCode',
        },
        {
          label: 'Phòng học',
          field: 'roomName',
        },
        {
          label: 'Tuần',
          field: 'yearWeekCode',
        },
        {
          label: 'Thứ tiết',
          field: 'stringDayTurnExport',
        },
        {
          label: 'Giảng viên',
          field: 'teacherName',
        },
      ],
    }
  },
  computed: {
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.SCHEDULE)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.SCHEDULE)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.SCHEDULE)
    },
  },
  async created() {
    this.isLoading = true
    try {
      const [trainingSystems, departments, days] = await Promise.all([
        apiCommon.getTrainingSystems({ currentPage: 1, itemsPerPage: 1000 }),
        apiCommon.getDepartments({ currentPage: 1, itemsPerPage: 1000 }),
        apiCommon.getDays({ currentPage: 1, itemsPerPage: 1000 }),
      ])
      this.trainingSystems = trainingSystems || []
      this.departments = departments || []
      this.days = days || []

      if (this.trainingSystems.length > 0) {
        this.filter.trainingSystemId = this.trainingSystems[0].value
        const dataCourse = await apiCommon.getCourses(this.filter)
        if (dataCourse) {
          this.courses = dataCourse.courses || []
        }
      }
    } catch (e) {
      this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tải dữ liệu ban đầu'}`, 'XCircleIcon', 'danger', '')
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getMainDataFromStore()
    },
    async onPerPageChange(param) {
      this.updateParams({
        currentPage: 1,
        itemsPerPage: param.currentPerPage,
      })
      await this.getMainDataFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        const selectedColumn = this.table.fields.findIndex(e => e.field === field)
        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getMainDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getMainDataFromStore()
    },
    onImportScheduler() {
      this.$bvModal.show('modal-import-scheduler')
    },
    openModal() {
      this.dataSendForm = {}
      this.$bvModal.show('modal-schedule')
    },
    loadItems() {
      this.btnSearchClick()
    },
    showToast(title, icon, variant, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title, icon, variant, text,
        },
      })
    },
    async deleteItem(item) {
      this.itemDelete = item
      this.titleNameDelete = `Xóa lịch học tuần ${this.weeks.find(week => week.id === this.filter.yearWeekId)?.code || ''} của lớp độc lập ${item.creditClassCode}`
      this.$bvModal.show('modal-schedule-delete')
    },
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        this.itemDelete.checkRemoveAll = this.checkRemoveAll
        const result = await api.deleteScheduleByCreditClassAndRoomAndTeacher(this.itemDelete)
        if (result) {
          await this.getMainDataFromStore()
          this.showToast('Đã xóa thành công!', 'CheckIcon', 'success', '')
          this.$bvModal.hide('modal-schedule-delete')
        } else {
          this.showToast('Có lỗi xảy ra!', 'XCircleIcon', 'danger', '')
        }
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi xóa dữ liệu'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    async edit(data) {
      this.dataSendForm = data
      this.$bvModal.show('modal-schedule')
    },
    async onTrainingSystemsChange(event) {
      this.isLoading = true
      try {
        this.filter.trainingSystemId = event
        this.courses = []
        this.filter.courseId = ''
        this.courseSemesters = []
        this.filter.courseSemesterId = ''
        this.weeks = []
        this.filter.yearWeekId = ''
        const request = { ...this.filter, itemsPerPage: 50 }
        const dataCourse = await apiCommon.getCourses(request)
        this.courses = dataCourse ? dataCourse.courses : []
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tải danh sách khóa học'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    async onCoursesChange(event) {
      this.isLoading = true
      try {
        this.filter.courseId = event
        this.courseSemesters = []
        this.filter.courseSemesterId = ''
        this.weeks = []
        this.filter.yearWeekId = ''
        this.courseSemesters = (await apiCommon.getCourseSemesters({
          currentPage: 1,
          itemsPerPage: 10000,
          courseId: this.filter.courseId,
          status: null,
        })) || []
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tải danh sách học kỳ'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    async onCourseSemesterChange() {
      this.isLoading = true
      try {
        this.weeks = []
        this.filter.yearWeekId = ''
        this.weeks = await api.getYearWeek({ courseSemesterId: this.filter.courseSemesterId }) || []
        if (this.weeks && this.weeks.length > 0) {
          this.weeks.forEach(week => {
            week.code = `${week.code} (${week.startDate} - ${week.endDate})`
          })
        }
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tải danh sách tuần'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    async onDepartmentChange(event) {
      this.isLoading = true
      try {
        this.filter.departmentId = event
        this.subjects = []
        this.filter.subjectId = ''
        this.teachers = []
        this.filter.teacherId = ''
        const request = {
          ...this.filter,
          itemsPerPage: 1000,
        }
        const [subjects, teachers] = await Promise.all([
          apiCommon.getSubjects(request),
          apiCommon.getTeachers(request),
        ])
        this.subjects = subjects || []
        this.teachers = teachers || []
        this.teacherOptions = this.teachers
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tải danh sách học phần hoặc giảng viên'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    async onSubjectChange(event) {
      this.isLoading = true
      try {
        this.filter.creditClassId = ''
        const data = await api.getCreditClasses(this.filter)
        this.creditClasses = data || []
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tải danh sách lớp độc lập'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    async onCreditClassChange(event) {
      this.isLoading = true
      try {
        this.filter.teacherId = ''
        const request = {
          ...this.filter,
          itemsPerPage: 500,
          departmentId: null,
        }
        const data = await api.getTeachersByCreditClass(request)
        this.teachersByCreditClass = data || []
        this.teacherOptions = this.teachersByCreditClass
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tải danh sách giảng viên theo lớp'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    async saveDataForm(data) {
      this.isLoading = true
      const objData = {
        creditClassId: data.creditClassId,
        roomId: data.roomId,
        teacherId: data.teacherId,
        listDayCheck: data.listDayCheck,
        beginDate: data.beginDate,
        weeks: data.weeks,
      }
      try {
        const res = await api.createSchedule(objData)
        if (res.isSuccessful) {
          if (data.type === 0) {
            this.$bvModal.hide('modal-schedule')
          }
          this.isHandleSaveSuccess = true
          this.showToast(res.message || 'Thêm lịch học thành công!', 'CheckIcon', 'success', '')
        } else {
          this.showToast(res.message || 'Có lỗi xảy ra!', 'XCircleIcon', 'danger', '')
        }
      } catch (e) {
        this.showToast(`[${e.code || 'Error'}] ${e.message || 'Lỗi khi tạo lịch học'}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
      await this.getMainDataFromStore()
    },
    async getFileExport(type) {
      this.filterExport.type = type
      this.filterExport.trainingSystemId = this.filter.trainingSystemId
      this.filterExport.courseId = this.filter.courseId
      this.filterExport.courseSemesterId = this.filter.courseSemesterId
      this.filterExport.yearWeekId = this.filter.yearWeekId
      this.filterExport.departmentId = this.filter.departmentId
      this.filterExport.subjectId = this.filter.subjectId
      this.filterExport.creditClassId = this.filter.creditClassId
      this.filterExport.teacherId = this.filter.teacherId
      this.filterExport.dayId = this.filter.dayId
      try {
        if (!this.filter.trainingSystemId || !this.filter.courseId || !this.filter.courseSemesterId) {
          this.showToast('Vui lòng chọn thông tin hệ đào tạo, khóa học, học kỳ', 'XCircleIcon', 'warning', '')
          return false
        }
        const data = await api.exportScheduler(this.filterExport)
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'danh_sach_tkb.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },

    async getMainDataFromStore() {
      this.isLoading = true
      try {
        if (!this.filter.trainingSystemId || !this.filter.courseId || !this.filter.courseSemesterId) {
          this.showToast('Vui lòng chọn thông tin hệ đào tạo, khóa học, học kỳ', 'XCircleIcon', 'warning', '')
          return false
        }
        const response = await api.getSchedulers(this.filter)
        this.schedulers = response.records || []
        this.total = response.total || 0
        if (this.schedulers.length > 0) {
          this.schedulers.forEach(item => {
            // eslint-disable-next-line no-param-reassign
            item.dayTurns = []
            let stringDayTurnExport = ''
            const groupDays = item.groupDays ? item.groupDays.split(',') : []
            const groupDayIds = item.groupDayIds ? item.groupDayIds.split(',') : []
            const groupTurns = item.groupTurns ? item.groupTurns.split('|') : []
            const groupTurnIds = item.groupTurnIds ? item.groupTurnIds.split('|') : []
            let htmlDayTurn = ''
            const groupDayTurn = []
            if (groupDays.length > 0) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < groupDays.length; i++) {
                const dayTurn = { dayId: 0, turnIds: [] }
                groupTurns[i] = groupTurns[i].substr(0, 1).replace(',', '') + groupTurns[i].substring(1)
                htmlDayTurn += `<li class="m-0 p-0 list-group-item">&#128197;${groupDays[i]}: &#9200;[${groupTurns[i]}]</li>`
                stringDayTurnExport += `${groupDays[i]}(${groupTurns[i]})${i < groupDays.length - 1 ? ',' : '' }`
                dayTurn.dayId = groupDayIds[i]
                let turnIds = groupTurnIds[i].split(',')
                turnIds = turnIds.filter(t => t !== '')
                dayTurn.turnIds = turnIds
                groupDayTurn.push(dayTurn)
              }
            }
            // eslint-disable-next-line no-param-reassign
            item.schedule = `<ul class="m-0 p-0 list list-group-flush">${htmlDayTurn}</ul>`
            // eslint-disable-next-line no-param-reassign
            item.dayTurns = groupDayTurn
            item.stringDayTurnExport = stringDayTurnExport
            item.stringSubjectExport = `${item.subjectName}(${item.subjectCode})`
          })
        }
        this.table.items = this.schedulers
      } catch (e) {
        this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger', '')
      } finally {
        this.isLoading = false
      }
    },
    exportExcelTKB() {
      if (this.schedulers.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Không có dữ liệu để xuất!',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }
      const data = []
      const header = {}
      this.columnsExport.forEach(column => {
        header[column.field] = column.label
      })
      const headerKeys = Object.keys(header)
      const dataSourceKeys = Object.keys(this.schedulers[0])
      const duplicates = dataSourceKeys.filter(val => headerKeys.includes(val))
      duplicates.sort((a, b) => headerKeys.indexOf(a) - headerKeys.indexOf(b))
      this.schedulers.forEach(dataSource => {
        const elm = {}
        duplicates.forEach(key => {
          elm[header[key]] = dataSource[key]
        })
        data.push(elm)
      })
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'ThoiKhoaBieu')
      XLSX.writeFile(wb, 'ThoiKhoaBieu.xlsx')
    },
  },
}
</script>

<style scoped>
</style>
